/**
 * Auth Provider for long-lived API access tokens
 */
const {
  EmitterInterface
} = require('../utils/events');

const events = require('../events');

const MemoryStore = require('../stores/memory-store');

const AuthToken = require('./auth-token');

const AUTH_TOKEN_KEY = 'TokenProvider.authTokens';

class TokenProvider extends EmitterInterface {
  constructor(store
  /*: ?Storage*/
  ) {
    super();
    this.store = store || new MemoryStore();
  } // Token management
  // Access tokens


  getTokens()
  /*: Promise<AuthToken | null>*/
  {
    const saved = this.store.load(AUTH_TOKEN_KEY);
    return Promise.resolve(new AuthToken(saved.access));
  } // eslint-disable-next-line class-methods-use-this


  getTokenPrefix() {
    return 'Api';
  }

  setTokens(token
  /*: AuthToken*/
  ) {
    this.store.save(AUTH_TOKEN_KEY, {
      access: token.access
    });
    this.emit(events.AUTH_CHANGED);
  }

  setRaw(access
  /*: string*/
  ) {
    this.setTokens(new AuthToken(access));
  }

  deleteTokens() {
    this.store.save(AUTH_TOKEN_KEY, null);
  }

  logout() {
    this.deleteTokens();
    this.emit(events.AUTH_LOGOUT);
  }

}

module.exports = TokenProvider;